import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import Modal from 'components/Modal';
import { IStaffTicketResItem } from 'features/user/services/types/ticket';
import StaffItemCallAction from './StaffItemCallAction';
import styled from 'styled-components';

type CallStaffsModalRef = {
    open: (billId: string, data: IStaffTicketResItem[]) => void;
}

export const useCallStaffsModalRef = () => useRef<CallStaffsModalRef>(null);
const CallStaffsModal = forwardRef<CallStaffsModalRef>((_, ref) => {

    const [open, setOpen] = useState(false);
    const [staffs, setStaffs] = useState<IStaffTicketResItem[]>([]);
    const [billId, setBillId] = useState<string>('');

    const onOpen = (billId: string, data: IStaffTicketResItem[]) => {
        setOpen(true);
        setBillId(billId);
        setStaffs(data);
    };

    const onClose = () => {
        setOpen(false);
        setStaffs([]);
    };

    useImperativeHandle(ref, () => ({
        open: onOpen,
    }));

    if (!open) return null;
    return (
        <Modal
            visible={open}
            onClose={onClose}
            hiddenHeader
            hiddenOkButton
            cancelTitle={'Close'}
            v2
            noneBodyStyle={true}
            footer={null}
            width={'auto'}
            destroyOnClose={true}
        >
            <Container onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}>
                <StaffsContainer>
                    {staffs?.map((staff) => (
                        <StaffItemCallAction key={staff.staffId} staff={staff} billId={billId} />
                    ))}
                </StaffsContainer>
                <CloseButton type='button' onClick={onClose}>Close</CloseButton>
            </Container>
        </Modal>
    );
});

CallStaffsModal.displayName = 'CallStaffsModal';
export default CallStaffsModal;


const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
`;

const StaffsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
    max-width: 1000px;
    width: fit-content;
`;

const CloseButton = styled.button`
    display: flex;
    height: 56px;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    border-radius: 4px;
    background: #E5E6EB;
    box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.40), 0 4px 8px -3px rgba(45, 35, 66, 0.30), 0 -3px 0 0 #D6D6E7 inset;
    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;